import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TransformationSection } from './components/TransformationSection';
import { BenefitsSection } from './components/BenefitsSection';
import { WhatYouGet } from './components/WhatYouGet';
import { BonusSection } from './components/BonusSection';
import { OfferSection } from './components/OfferSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    try {
      // Forward fbclid to cart links for Meta attribution
      const params = new URLSearchParams(window.location.search);
      const fbclid = params.get('fbclid');
      if (fbclid) {
        document.addEventListener('click', function (e: MouseEvent) {
          const target = (e.target as HTMLElement)?.closest('a');
          if (!target) return;
          if (target.href && target.href.includes('mareaa.online')) {
            e.preventDefault();
            const separator = target.href.includes('?') ? '&' : '?';
            window.location.href = target.href + separator + 'fbclid=' + fbclid;
          }
        });
      }
      // Meta Pixel initialization
      if (typeof window !== 'undefined' && !window.fbq) {
        const n: any = function () {
          if (n.callMethod) {
            n.callMethod.apply(n, arguments);
          } else {
            n.queue.push(arguments);
          }
        };
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [] as any[];
        window.fbq = n;
        if (!window._fbq) window._fbq = n;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        window.fbq('init', '1438495414738821');
        window.fbq('track', 'PageView');
      }
    } catch (e) {
      // Silently fail — pixel errors should not break the page
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-primary selection:bg-highlight selection:text-primary" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1438495414738821&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <AnnouncementBar data-id="element-3" />
      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <TransformationSection data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <WhatYouGet data-id="element-9" />
        <BonusSection data-id="element-10" />
        <OfferSection data-id="element-11" />
        <Testimonials data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}